interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "PLN";
};

const PLN: Currency = Object.freeze({
  "displayName": "Polish Zloty",
  "numericCode": 985,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "PLN",
  "symbol": "zł"
});

export { PLN };
